// src/components/GlowPaper.js
import React from 'react';
import { Paper, styled } from '@mui/material';

const GlowPaper = styled(Paper)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 12, // Default border radius
  transition: 'border-radius 0.3s ease', // Smooth transition between states

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 'inherit', // Inherits from parent
    padding: '2px',
    background: 'linear-gradient(45deg, #00ffff, #ff00ff, #ffff00)',
    WebkitMask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
    mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
    animation: 'glow 3s linear infinite',
    opacity: 0.3,

    [theme.breakpoints.down('sm')]: {
      padding: '1px',
      animation: 'glow 5s linear infinite',
      opacity: 0.5,
    }
  },

  // Responsive border radius
  [theme.breakpoints.down('sm')]: {
    borderRadius: 8, // Slightly smaller radius on mobile
  }
}));

export default GlowPaper;